// API
import api from '../../api'

// Constants
import { KeyConstants } from '../../constants'

// Utilities
import Logger from '../../utility/loggerUtil'
import Preference from '../../utility/preferenceUtil'

export default {
  async getOffers (context) {
    try {
      const response = await api.offers.getOffers()

      if (response && response.offers) {
        context.commit('setOffers', response.offers)
        await context.dispatch('calculateUnviewedOffersCount', response.offers)
      }
    } catch (e) {
      Logger.error('Error on offers.actions.getOffers')
      Logger.debug(e)
      throw e
    }
  },

  async calculateUnviewedOffersCount (context) {
    const viewedOfferIds = JSON.parse(await Preference.get(KeyConstants.viewedOfferIds, '[]')) || []
    let unviewedOffersCount = 0

    context.state.offers.forEach(offer => {
      if (viewedOfferIds.indexOf(offer.offerId) === -1) {
        unviewedOffersCount++
      }
    })

    context.commit('setUnviewedOffersCount', unviewedOffersCount)
  },

  async setOfferViewed (context, offerId) {
    const viewedOfferIds = JSON.parse(await Preference.get(KeyConstants.viewedOfferIds, '[]')) || []

    if (viewedOfferIds.indexOf(offerId) === -1) {
      viewedOfferIds.push(offerId)
      await Preference.set(KeyConstants.viewedOfferIds, JSON.stringify(viewedOfferIds))
    }

    await context.dispatch('calculateUnviewedOffersCount')
  }
}
